import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsers = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 9.006,
			cy: 5.982,
			r: 4.031,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 9.006,
			cy: 17.067,
			fill: "currentColor",
			rx: 7.054,
			ry: 4.031
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M21.096 17.067c0 1.67-2.051 3.023-4.556 3.023.738-.806 1.245-1.818 1.245-3.021 0-1.205-.508-2.218-1.247-3.025 2.504 0 4.558 1.354 4.558 3.023ZM18.073 5.982a3.023 3.023 0 0 1-4.06 2.841c.477-.838.749-1.808.749-2.842a5.732 5.732 0 0 0-.748-2.84 3.023 3.023 0 0 1 4.059 2.841Z"
		})
	]
});
const ForwardRef = forwardRef(SvgUsers);
export default ForwardRef;
